import React from 'react';
import cn from 'classnames';
import { useStateSelector } from '../../providers/stateManager';
import Actions from './Actions';
import CommentCard from '../CommentCard';
import { selectEditCommentId } from '../../utils/selectors';
import styles from './index.module.scss';

const CommentBlock = ({ comment, isAuthor, canEditComment }) => {
  const editCommentId = useStateSelector(selectEditCommentId);

  const isEdited = editCommentId === comment.id;

  return (
    <div data-author={isAuthor} className={styles.root}>
      {isAuthor && (
        <Actions
          className={styles.actions}
          canEditComment={canEditComment}
          comment={comment}
        />
      )}

      <CommentCard
        comment={comment}
        className={cn(styles.card, {
          [styles.editedCard]: isEdited,
          [styles.owner]: isAuthor,
        })}
      />
    </div>
  );
};

export default CommentBlock;
